import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ToastFile from "../../utils/ToastFile";
import { addRoute, updateRoute } from "../../api/RouteApi";

const AddUpdateRouteInfo = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isActionEdit, setIsActionEdit] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (state?.route) {
      setIsActionEdit(true);
      reset(state?.route);
    } else {
      setIsActionEdit(false);
    }
  }, []);

  const onSubmit = (data) => {
    let payload = {
      ...data,
      tenant_id: user.tenant_id,
      createdBy: user.user_id,
      createdAt: new Date(),
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
    };
    if (isActionEdit) {
      updateRoute(state?.route?._id, payload)
        .then((res) => {
          if (res.status === 200) {
            ToastFile("Route updated successfully", "updated");
            reset();
            navigate("/routeInfo");
          } else {
            ToastFile("Failed to update route", "error");
          }
        })
        .catch((err) => {
          console.error("Error updating route:", err);
          ToastFile("Error updating route", "error");
        });
      
    } else {
      addRoute(payload)
        .then((res) => {
          if (res.status === 201) {
            ToastFile("Route added successfully", "added");
              navigate("/routeInfo");
          } else {
            ToastFile("Failed to add route", "error");
          }
        })
        .catch((err) => {
          console.error("Error adding route:", err);
          ToastFile("Error adding route", "error");
        });
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0"> {isActionEdit ? "Edit Route Information" : "Add Route Information"}</h3>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group className="mb-3">
            <Form.Label>Route No</Form.Label>
            <Form.Control
              type="text"
              {...register("distance", { required: false })}
              isInvalid={errors.distance}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Route Name</Form.Label>
            <Form.Control
              type="text"
              {...register("routeName", { required: false })}
              isInvalid={errors.routeName}
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Contractor No</Form.Label>
            <Form.Control
              as="textarea"
              row={4}
              {...register("description", { required: false })}
              isInvalid={errors.description}
            />
          </Form.Group>

          <Button variant="primary" type="submit">
            {isActionEdit ? "Update" : "Add"}
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => navigate("/routeInfo")}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </Layout>
  );
};

export default AddUpdateRouteInfo;
